/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ComplianceStatus = {
    Compliant: 'COMPLIANT',
    NotCompliant: 'NOT_COMPLIANT'
} as const;
export type ComplianceStatus = typeof ComplianceStatus[keyof typeof ComplianceStatus];


export function instanceOfComplianceStatus(value: any): boolean {
    for (const key in ComplianceStatus) {
        if (Object.prototype.hasOwnProperty.call(ComplianceStatus, key)) {
            // @ts-ignore
            if (ComplianceStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ComplianceStatusFromJSON(json: any): ComplianceStatus {
    return ComplianceStatusFromJSONTyped(json, false);
}

export function ComplianceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceStatus {
    return json as ComplianceStatus;
}

export function ComplianceStatusToJSON(value?: ComplianceStatus | null): any {
    return value as any;
}

